exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".chips-container {\n  display: flex;\n  flex-flow: row wrap;\n  margin: -0.25rem;\n}\n.chips-container.stacked {\n  flex-flow: column nowrap;\n}\n.chips-container > .chips {\n  margin: 0.25rem;\n}", ""]);
